import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import RouteLoader from "../components/RouteLoader";
import { ROUTE_PATHS } from "./paths";

const LoadingGate = () => <RouteLoader />;

export const RedirectAdminToDashboard = ({ children }) => {
  const { isAuthenticated, isAuthLoading, user } = useAuth();

  if (isAuthLoading) return <LoadingGate />;

  if (isAuthenticated && user?.role === "admin") {
    return <Navigate to={ROUTE_PATHS.adminRoot} replace />;
  }

  return children;
};

export const RequireCustomerAuth = ({ children, redirect = ROUTE_PATHS.login }) => {
  const { isAuthenticated, isAuthLoading, user } = useAuth();
  const location = useLocation();

  if (isAuthLoading) return <LoadingGate />;

  if (!isAuthenticated) {
    return <Navigate to={redirect} replace state={{ from: location.pathname }} />;
  }

  if (user?.role === "admin") {
    return <Navigate to={ROUTE_PATHS.adminRoot} replace />;
  }

  return children;
};

export const RequireAuthOrRegisterAddress = ({ children, redirect = ROUTE_PATHS.login }) => {
  const { isAuthenticated, isAuthLoading, user } = useAuth();
  const location = useLocation();

  if (isAuthLoading) return <LoadingGate />;

  if (isAuthenticated && user?.role === "admin") {
    return <Navigate to={ROUTE_PATHS.adminRoot} replace />;
  }

  if (location.state?.from === "register") {
    return children;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirect} replace state={{ from: location.pathname }} />;
  }

  return children;
};

export const RequireAdmin = ({ children }) => {
  const { isAuthenticated, isAuthLoading, user } = useAuth();

  if (isAuthLoading) return <LoadingGate />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTE_PATHS.login} replace />;
  }

  if (user?.role !== "admin") {
    return <Navigate to={ROUTE_PATHS.home} replace />;
  }

  return children;
};






